const DEFAULT_POLL_MS = 2500

export function bulkInvoiceSendStorageKey(packageUUID) {
  return `bulk-reserved-invoice-send:${packageUUID}`
}

export function readStoredInvoiceSendBatchId(packageUUID) {
  try {
    return sessionStorage.getItem(bulkInvoiceSendStorageKey(packageUUID)) || ''
  } catch (_) {
    return ''
  }
}

export function storeInvoiceSendBatchId(packageUUID, batchId) {
  try {
    sessionStorage.setItem(bulkInvoiceSendStorageKey(packageUUID), batchId)
  } catch (_) {}
}

export function clearStoredInvoiceSendBatchId(packageUUID) {
  try {
    sessionStorage.removeItem(bulkInvoiceSendStorageKey(packageUUID))
  } catch (_) {}
}

/**
 * Poll a queued reserved-invoice send until it completes or fails.
 * Returns a stop function. In-flight responses after stop are ignored.
 */
export function startBulkReservedInvoiceSendPoll(batchId, options = {}) {
  const {
    fetchStatus,
    onProgress,
    onCompleted,
    onFailed,
    pollMs = DEFAULT_POLL_MS,
  } = options
  const id = String(batchId ?? '').trim()
  let stopped = false
  if (!id || typeof fetchStatus !== 'function') {
    return () => {
      stopped = true
    }
  }

  const poll = async () => {
    if (stopped) return
    try {
      const res = await fetchStatus(id)
      if (stopped) return
      const job = res?.data
      const status = job?.status
      if (status === 'completed') {
        onCompleted?.(job)
        return
      }
      if (status === 'failed') {
        onFailed?.(job)
        return
      }
      onProgress?.(job)
      if (!stopped) setTimeout(poll, pollMs)
    } catch (error) {
      if (stopped) return
      if (Number(error?.response?.status) === 404) {
        onFailed?.({ error: 'Invoice send job not found', status: 'failed' })
        return
      }
      setTimeout(poll, pollMs)
    }
  }

  poll()
  return () => {
    stopped = true
  }
}
